// Small atomic components to be reused and composed into larger components
// These should be moved to somewhere more sensible if they're used anywhere else

import styled from 'styled-components';
import { Colors, Font } from 'web-common/src/shared/styles';

export const Heading = styled.div`
  font-family: ${Font.Family.SANS};
  font-weight: 400;
  font-size: 48px;
  color: #383838;
  letter-spacing: 0;
`;

export const Light = styled.div`
  font-family: ${Font.Family.SANS};
  font-weight: 400;
  font-size: 13px;
  color: #b8b8b8;
  letter-spacing: 1.5px;
`;

export const Regular = styled.div`
  font-family: ${Font.Family.SANS};
  font-weight: 400;
  font-size: 15px;
  color: #383838;
  letter-spacing: 0;
`;

export const Strong = styled.div`
  font-family: ${Font.Family.SANS};
  font-weight: 700;
  font-size: 15px;
  color: #383838;
  letter-spacing: 0;
`;

export const BlackSmall = styled.div`
  font-family: ${Font.Family.SANS};
  font-weight: 400;
  font-size: 12px;
  color: #383838;
  letter-spacing: 0;
  line-height: 20px;
`;

export const Gray = styled.div`
  font-family: ${Font.Family.SANS};
  font-weight: 400;
  font-size: 15px;
  color: ${Colors.GRAY_DARK_10};
  letter-spacing: 0;
  line-height: 22px;
`;

export const GraySmall = styled.div`
  font-family: ${Font.Family.SANS};
  font-weight: 400;
  font-size: 12px;
  color: ${Colors.GRAY_DARK_10};
  letter-spacing: 0;
  line-height: 20px;
`;

interface DividerProps {
  marginBottom?: number;
  marginTop?: number;
  margin?: string;
  gridColumn?: string;
}

const DEFAULT_DIVIDER_MARGIN = 32;
const DEFAULT_GRID_COLUMN = 'auto';

export const Divider = styled.div<DividerProps>`
  border-bottom: 1px solid ${Colors.GRAY_LITE_10};
  width: 100%;
  height: 0;

  margin: ${({ margin, marginTop = DEFAULT_DIVIDER_MARGIN, marginBottom = DEFAULT_DIVIDER_MARGIN }) => {
    if (margin) return margin;
    return `${marginTop}px 0 ${marginBottom}px 0`;
  }};
  grid-column: ${({ gridColumn = DEFAULT_GRID_COLUMN }) => gridColumn};
`;

export const Spacer = styled.div`
  width: 100%;
  height: 30px;
`;

interface RatingBarProps {
  percent: number;
  height?: number;
  grow?: number;
}

export const RatingBar = styled.div<RatingBarProps>`
  flex-grow: ${({ grow }) => grow ?? 1};
  height: ${({ height }) => height || 8}px;
  background: linear-gradient(90deg, #ffc513 ${({ percent }) => percent}%, #ebebeb ${({ percent }) => percent}%);
`;

interface ButtonProps {
  icon?: string;
}

const getIcon = ({ icon }: ButtonProps) => {
  if (icon) {
    return `url(${icon}) !important`;
  }
  return null;
};

export const Button = styled.button<ButtonProps>`
  background: #f7f7f7 !important;
  font-family: ${Font.Family.SANS} !important;
  font-weight: 400 !important;
  font-size: 10px !important;

  border: none !important;
  border-radius: 4px !important;
  height: 30px !important;
  width: 100% !important;
  box-sizing: border-box !important;
  text-align: left !important;

  background-image: ${getIcon};
  background-position: center right 6px !important;
  background-repeat: no-repeat !important;
`;

export const ThumbImg = styled.img`
  height: 16px;
  width: auto;
  margin-right: 4px;
`;

interface IconCountProps {
  active: boolean;
}
export const IconCount = styled.div<IconCountProps>`
  display: flex;
  opacity: ${({ active }) => (active ? 1 : 0.5)};
  align-items: center;
`;

export const Tag = styled(GraySmall)`
  line-height: 30px;
  box-sizing: border-box;
  border: 1px solid #d8d8d8;
  border-radius: 4px;
  height: 30px;
  padding: 0px 8px;
  white-space: nowrap;
`;

export const DisableOverlay = styled(Gray)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  padding-top: 40%;
  text-align: center;
  background-color: rgba(235, 235, 235, 0.85);
`;

// A button styled to look like a hyperlink
export const LinkButton = styled.button`
  text-decoration: underline;
  background-color: white;
  border: none;
`;
